import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TopicsPage from "../pages/topics/page";
import TopicDetailPage from "../pages/topics/detail/page";
import MethodPage from "../pages/method/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topics",
    element: <TopicsPage />,
  },
  {
    path: "/topic/:id",
    element: <TopicDetailPage />,
  },
  {
    path: "/method",
    element: <MethodPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;